import * as betgalaxy from './Empty.styles.betgalaxy';
import * as betprofessor from './Empty.styles.betprofessor';
import * as betroyale from './Empty.styles.betroyale';
import * as goldenrush from './Empty.styles.goldenrush';
import * as juicybet from './Empty.styles.juicybet';
import * as puntcity from './Empty.styles.puntcity';
import * as puntgenie from './Empty.styles.puntgenie';
import * as questbet from './Empty.styles.questbet';
import * as sterlingparker from './Empty.styles.sterlingparker';
import * as vikingbet from './Empty.styles.vikingbet';
import * as volcanobet from './Empty.styles.volcanobet';
import * as wellbet from './Empty.styles.wellbet';
import * as forsport from './Empty.styles.forsport';
import * as fiestabet from './Empty.styles.fiestabet';
import * as junglebet from './Empty.styles.junglebet';
import * as oldgill from './Empty.styles.oldgill';
import * as sugarcastle from './Empty.styles.sugarcastle';
import * as buffalobet from './Empty.styles.buffalobet';
import * as titanbet from './Empty.styles.titanbet';
import * as templebet from './Empty.styles.templebet';
import * as slambet from './Empty.styles.slambet';
import * as gigabet from './Empty.styles.gigabet';
import * as betstride from './Empty.styles.betstride';
import * as goldenbet888 from './Empty.styles.goldenbet888';
import * as hyperbet from './Empty.styles.hyperbet';
import * as bet777 from './Empty.styles.bet777';
import * as chromabet from './Empty.styles.chromabet';
import * as bet575 from './Empty.styles.bet575';
import * as betblast from './Empty.styles.betblast';
import * as pyramidbet from './Empty.styles.pyramidbet';
import * as magnumbet from './Empty.styles.magnumbet';

import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  betgalaxy,
  betprofessor,
  betroyale,
  goldenrush,
  juicybet,
  puntcity,
  puntgenie,
  questbet,
  sterlingparker,
  vikingbet,
  volcanobet,
  wellbet,
  forsport,
  fiestabet,
  junglebet,
  oldgill,
  sugarcastle,
  buffalobet,
  titanbet,
  templebet,
  slambet,
  gigabet,
  betstride,
  goldenbet888,
  hyperbet,
  bet777,
  chromabet,
  bet575,
  betblast,
  pyramidbet,
  magnumbet,
};
